import { create } from 'superstruct';

import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';
import { IconVariationsValidator } from '../validators/IconVariation';

export async function fetchIconVariations(iconId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/download_variations/${iconId}`;
  const response = await get<ApiIconVariationsResponse>(requestUrl);
  return create(response, IconVariationsValidator);
}
